import React from "react";
import { Button, dialog, InputString, printComponent } from "../../../nq-component";
import {
  addSchemaUseCase,
  updateSchemaUseCase,
  deleteSchemaUseCase,
} from "../../../usecases/schema/usecases";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { exportCSVUseCase } from "../../../usecases/csv/usecases";
import { Progress, InfiniteScroll } from "../../../nq-component";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import BaseListPage from "../../../base/BaseListPage";
import NavBar from "../../../components/navbar";
import InputFactory from "../../../components/InputFactory";

import excludeFields from "./components/./ExcludeField";
import DialogCreate from "./components/DialogCreate";
import Table from "../../../components/Table";
import DialogDelete from "./components/DialogDelete";

import ResignationListPresenter from "./ResignationListPresenter";
import DialogConfirmation from "./components/DialogConfirmation";
import { footer } from "framer-motion/m";
import ResignationDetails from "./components/ResignationDetails";
import DialogDate from "./components/DialogDate";
import ExitInterviewPDF from "../../../components/ExitInterviewPDF";

class ResignationListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ResignationListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      exportCSVUseCase(),
      addSchemaUseCase(),
      updateSchemaUseCase(),
      deleteSchemaUseCase(),
      getObjectUseCase()
    );
    this.state = {
      objects: [],
      selected: [],
      loading: false,
      total: 0,
      count: 0,
      remarks: "",
      date: null,
      amount: 0,
      showDetails: false,
      showFilters: false,
      resignationDetails: {},
      formData: {
        id: "",
        positionTitle: {},
        slotVacancy: 0,
        qualificationStandard: "",
        jobDescription: "",
        deadline: "",
      },
      password: {},
      exitInterview: {},
    };

    this.exitInterviewPDF = React.createRef();
  }

  getCollectionName() {
    return "resignation";
  }

  getToken() {
    return this.getParams().token;
  }

  onChangeObject(value, field) {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [field]: value,
      },
    }));
  }

  handleSubmit = () => {
    this.presenter.handleSubmit(this.state.formData);
  };

  // clickData(object, index) {
  //   this.setState({ showDetails: true, empDetails: object });
  // }

  hideFilter() {
    this.setState({ showDetails: false });
  }

  onClickEdit() {
    const { objects } = this.state;
    this.presenter.onClickEdit(objects);
  }

  handleDelete() {
    const { empDetails } = this.state;
    this.presenter.onClickDelete(empDetails);
  }

  onSubmitPassword() {
    this.presenter.onSubmitPassword(this.state.password);
  }
  onChange(value, field) {
    this.setState((prevState) => ({
      password: {
        ...prevState.password,
        [field]: value,
      },
    }));
  }

  onClickAdd(object) {
    const schema = this.getSchemas();
    const formData = this.state.formData;

    dialog.fire({
      html: (
        <DialogCreate
          schema={schema}
          objects={object}
          onChangeData={this.onChangeObject.bind(this)}
          handleSubmit={this.handleSubmit.bind(this)}
        />
      ),
      footer: false,
    });
  }

  onClickDelete() {
    const { empDetails } = this.state;
    dialog.fire({
      html: (
        <>
          <DialogDelete
            empDetails={empDetails}
            clickDelete={this.handleDelete.bind(this)}
            clickClose={() => dialog.close()}
          />
        </>
      ),
      footer: false,
    });
  }

  onclickView() {
    const { empDetails } = this.state;
    this.navigateTo(`/admin/job-details/view/${empDetails?.id}`);
  }

  getAcl() {
    const user = this.getCurrentUser();
    return {
      read: ["*", user.id],
      write: ["*", user.id],
    };
  }

  hideFilter() {
    this.setState({ showFilters: false });
  }
  showFilter() {
    this.setState({ showFilters: true });
  }

  getRecruiterName(object) {
    this.presenter.getRecruiterName(object?.recruiter?.employee?.id);
  }

  handleApproveSubmit(object) {
    this.presenter.onSubmitApprove(object);
  }

  handleRejectSubmit(object) {
    this.presenter.onSubmitReject(object);
  }

  getRecruiterName(id) {
    return this.presenter.getRecruiterName(id);
  }

  clickData(object, index) {
    this.setState({
      showFilters: true,
      showDetails: true,
      resignationDetails: object,
    });
  }

  onClickApprove(object) {
    const user = this.getCurrentUser();
    dialog.fire({
      html: (
        <DialogConfirmation
          user={user}
          object={object}
          onchange={this.onChangeRemarks.bind(this)}
          title={"Approve Resignation"}
          type={"approve"}
          handleConfirm={() => this.handleApproveSubmit(object)}
          onInputDate={this.inputDateDialog.bind(this)}
        />
      ),
      footer: false,
    });
  }

  onChangeRemarks(event) {
    const value = event.target.value;
    this.setState({ remarks: value });
  }

  onClickReject(object) {
    dialog.fire({
      html: (
        <DialogConfirmation
          object={object}
          onchange={this.onChangeRemarks.bind(this)}
          title={"Reject Resignation"}
          type={"reject"}
          handleConfirm={() => this.handleRejectSubmit(object)}
        />
      ),
      footer: false,
    });
  }

  onChangeDate(event) {
    const value = event.target.value;
    this.setState({ date: value });
  }

  onChangeAmount(event) {
    const value = event.target.value;
    this.setState({ amount: value });
  }

  handleLastPayDate(object) {
    this.presenter.handleLastPayDate(object);
  }

  inputDateDialog() {
    const { resignationDetails } = this.state;
    const user = this.getCurrentUser();

    try {
      dialog.close();
    } catch (err) {
      console.warn("No dialog to close:", err?.message || err);
    }

    dialog.fire({
      html: (
        <DialogDate
          user={user}
          object={resignationDetails}
          onchange={this.onChangeDate.bind(this)}
          onChangeAmount={this.onChangeAmount.bind(this)}
          handleConfirm={() => this.handleApproveSubmit(resignationDetails)}
          handleLastPayDate={() => this.handleLastPayDate(resignationDetails)}
        />
      ),
      footer: false,
    });
  }

  async fetchExitInterview() {
    return this.presenter.getExitInterview();
  }

  async printExitForm() {
    // const { resignationDetails } = this.state;
    // const id = resignationDetails?.employee?.exit_interview?.id;
    // this.navigateTo(`/exit-form/${id}`);
    await this.fetchExitInterview();
    printComponent(this.exitInterviewPDF.current);
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const exitFormSchema = this.getSchema("exit_interview");
    const {
      objects,
      selected,
      count,
      progress,
      showFilters,
      showDetails,
      resignationDetails,
      exitInterview,
    } = this.state;

    if (!schema) return <Progress />;
    const user = this.getCurrentUser();

    console.log(objects);
    const statusOptions = [
      "Pending",
      "In Progress",
      "Approved",
      "Disapproved",
      "Completed",
    ];

    const excludedFields = [
      "recruiterStatus",
      "coordinatorStatus",
      "coordinator",
      "recruiter",
      "hrStatus",
      "recruiterRemarks",
      "coordinatorRemarks",
      "hrRemarks",
      "adminRemarks",
      "lastPayDate",
      "accountingStatus",
      "accountingRemarks",
      "dueDate",
    ];
    return (
      <>
        <div className="d-none">
          <div ref={this.exitInterviewPDF}>
            <ExitInterviewPDF
              object={exitInterview}
              schema={exitFormSchema}
              employee={resignationDetails?.employee}
            />
          </div>
        </div>
        <NavBar user={user} />
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4" style={{ height: `100vh` }}>
              <div className="d-flex align-items-center justify-content-between">
                <h1 className="text-capitalize fw-bold">
                  {schema.label || this.getCollectionName()}
                </h1>
                <div className="text-nowrap">
                  <span className="ms-2">
                    {selected.length > 0 ? "Selected: " : "Total: "}
                  </span>
                  <span className="text-nowrap fs-sm">
                    {selected.length > 0 ? selected.length : objects.length}
                  </span>
                  <span className="ms-1">of </span>
                  <span className="text-nowrap fs-sm">{count}</span>
                </div>
              </div>

              <div className="d-flex justify-content-start">
                <p
                  className="align-self-end m-0 cursor-pointer fw-bold"
                  style={{ color: `#D18237` }}
                  onClick={this.showFilter.bind(this)}
                >
                  <i class="bi bi-filter"></i>Filters
                </p>
              </div>
              <div className="d-flex flex-column flex-md-row">
                {showFilters ? (
                  <div
                    className="d-flex flex-column w-50 me-2"
                    style={{
                      width: "50%",
                      position: "sticky",
                      top: 0,
                      alignSelf: "flex-start",
                      zIndex: 1,
                    }}
                  >
                    <div className="card p-3 mt-1">
                      <h6 className="fw-bold" style={{ color: "black" }}>
                        <i
                          className="bi bi-arrow-left cursor-pointer me-2"
                          onClick={this.hideFilter.bind(this)}
                        ></i>
                        Filters
                      </h6>

                      <div className="d-flex mt-3 d-flex flex-column gap-2">
                        {Object.keys(schema.filters || {}).map((field) => {
                          let { type, ...options } = schema.filters[field];
                          return (
                            <InputFactory
                              key={field}
                              className="ms-1"
                              type={type}
                              field={field}
                              where={{}}
                              onChange={this.onChangeFilter.bind(this, type)}
                              {...options}
                            />
                          );
                        })}
                      </div>
                    </div>
                    {showDetails ? (
                      <ResignationDetails
                        user={user}
                        inputDate={() => this.inputDateDialog()}
                        clickApprove={() =>
                          this.onClickApprove(resignationDetails)
                        }
                        clickReject={() =>
                          this.onClickReject(resignationDetails)
                        }
                        object={resignationDetails}
                        printExitForm={this.printExitForm.bind(this)}
                        loading={progress}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  ""
                )}
                <div className="w-100">
                  <Table
                    fields={schema.fields}
                    onClick={this.clickData.bind(this)}
                    objects={objects}
                    excludeFields={Object.keys(schema.fields).reduce(
                      (acc, key) => {
                        const options = schema.fields[key];
                        if (excludedFields.includes(key)) {
                          acc.push(key);
                        }
                        if (options.read === false) {
                          acc.push(key);
                        }
                        switch (options._type || options.type) {
                          case "Relation":
                          case "Array":
                          case "Object":
                          case "File":
                            acc.push(key);
                            break;
                          default:
                        }
                        return acc;
                      },
                      excludeFields
                    )}
                    selected={selected}
                    onSelect={this.onSelect.bind(this)}
                    onSelectAll={this.onSelectAll.bind(this)}
                    progress={progress}
                    onClickItem={this.onClickItem.bind(this)}
                    onSort={this.onClickSort.bind(this)}
                    className="mt-1"
                  />
                </div>
              </div>
            </div>
          </InfiniteScroll>
        </div>
        {/* <div className="m-4 position-fixed bottom-0 end-0">
          <Button
            className="btn shadow-sm text-white"
            onClick={this.onClickAdd.bind(this)}
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "25px",
              backgroundColor: "#e09552",
            }}
          >
            <i className="bi bi-plus-lg" />
          </Button>
        </div> */}
      </>
    );
  }
}

export default withRouter(ResignationListPage);
